import type { ChangeEvent, RefObject } from "react";
import { useEffect } from "react";
import * as Styled from "./style";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";

export type SearchFormProps = {
  /** 検索履歴リストの表示状態 */
  searchInputRef: RefObject<HTMLLabelElement>;
  /** 検索フォーム表示状態 */
  isShowSearch: boolean;
  /** 検索キーワード */
  keyword: string;
  /** 検索キーワード更新関数 */
  onChangeText: (e: ChangeEvent<HTMLInputElement>) => void;
  /** 検索キーワード初期化関数 */
  onClickClearButton: () => void;
  /** 検索フォームキャンセルボタン押下時処理 */
  onCancel: () => void;
  /** 検索フォームからフォーカスを外した時の処理 */
  onBlur: () => void;
};

export const Form = (props: SearchFormProps) => {
  const { searchInputRef, isShowSearch, keyword, onChangeText, onClickClearButton, onCancel, onBlur } = props;
  const { handleClickByDevice } = useHandleClickByDevice();

  const disableKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const assignFocusToInput = () => {
    const targetElement = searchInputRef.current;
    if (!targetElement) return;
    const inputElement = targetElement.querySelector("input") as HTMLInputElement;
    inputElement.focus();
  };
  useEffect(assignFocusToInput, []);

  return (
    <Styled.DivAnimationContainer isShowElement={isShowSearch}>
      <Styled.InputSearchForm
        ref={searchInputRef}
        name="search"
        placeholder="作品名・人名で検索"
        type="text"
        value={keyword}
        onChange={onChangeText}
        onClickClearButton={onClickClearButton}
        iconName="search"
        iconSize="M"
        fontSize="S"
        iconColor="GRAY900"
        onKeyDown={disableKeyDown}
        onBlur={onBlur}
        maxLength={1000}
        isCounterArea={false}
      />
      <Styled.Button
        {...handleClickByDevice<HTMLButtonElement>(() => {
          onCancel();
        })}
      >
        キャンセル
      </Styled.Button>
    </Styled.DivAnimationContainer>
  );
};
